import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { logo, physicianchat, profileimg } from "../Constant/Index";
import { useSelector } from "react-redux";
import { physicianWriteperscription } from "../network/Network";
import Swal from "sweetalert2";

const UserWriteNow = () => {
	const navigate = useNavigate();
	const allphysician = useSelector((state) => state?.Auth?.physiciandetail);
	const token = useSelector((state) => state?.Auth?.token);
	const userDetail = useSelector((state) => state?.Auth?.users);
	const [prescriptions, setPrescriptions] = useState([]);
	const [quantities, setQuantities] = useState([]);
	const [prescriptiondetail, setPrescriptiondetail] = useState("");
	const [prescription, setPrescription] = useState("");
	const [quantity, setQuantity] = useState("");
	const [loading, setLoading] = useState(false);

	const handleAdd = () => {
		setPrescriptions([...prescriptions, { prescription, quantity }]);
		setPrescription("");
		setQuantity("");
	};

	// / Function to remove an item by index
	const handleRemove = (index) => {
		setPrescriptions(prescriptions.filter((_, i) => i !== index));
		setQuantities(quantities.filter((_, i) => i !== index));
	};
	// =====================
	const prescriptionHandler = (e) => {
		e.preventDefault();
		setLoading(true);
		console.log(prescriptions, "454533dsdsd");
		if (prescriptions.length === 0) {
			Swal.fire({
				position: "center",
				icon: "error",
				text: "Please add at least one prescription",
				showConfirmButton: false,
				timer: 1500,
			});
			setLoading(false);
			return;
		}

		if (!prescriptiondetail) {
			Swal.fire({
				position: "center",
				icon: "error",
				text: "Please add some detail",
				showConfirmButton: false,
				timer: 1500,
			});
			setLoading(false);
			return;
		}

		let data = {
			appointment_id: allphysician?.booking_detail?.booking_id,
			prescriptions: prescriptions,
			detail: prescriptiondetail,
		};

		physicianWriteperscription(data, token)
			.then((res) => {
				setLoading(false);
				Swal.fire({
					position: "center",
					icon: "success",
					text: "Prescription submitted successfully!",
					showConfirmButton: false,
					timer: 1500,
				});
				navigate(
					`/physician-consultation-detail/${allphysician?.booking_detail?.booking_id}`,
				);
				setPrescriptions([]);
			})
			.catch((err) => {
				setLoading(false);
				Swal.fire({
					position: "center",
					icon: "error",
					text: "Failed to submit the prescription. Please try again.",
					showConfirmButton: false,
					timer: 1500,
				});
			});
	};

	return (
		<>
			<Header />
			<PageHeader pagename="Write Prescription " />
			<section className="main-sidebar user-profile Physician">
				<div className="container">
					<div className="row">
						<div className="col-lg-8 mx-auto">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div className="edit-btn back">
										<Link
											to={`/physician-consultation-detail/${allphysician?.booking_detail?.booking_id}`}
										>
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex gap-3 align-items-center">
										<img
											src={
												userDetail?.profile_image_url
													? userDetail?.profile_image_url
													: physicianchat
											}
											className="img-fluid profie_img"
											alt=""
										/>
										<div>
											<h4 className="main-heading-font level-6 mb-0">
												Dr {userDetail?.first_name}
											</h4>
											<h5 className="primary-medium-font level-8  mb-0 extra-color-15">
												Physician
											</h5>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<div className="note-write-texterea">
											<img src={logo} className="img-fluid" alt="" />
										</div>
										<div className="row">
											<div className="col-lg-12">
												<div className="write_prescription_quantity mt-3">
													<h2>Prescription Form</h2>
													<input
														type="text"
														placeholder="Prescription"
														value={prescription}
														onChange={(e) => setPrescription(e.target.value)}
													/>
													<input
														type="number"
														placeholder="Quantity"
														value={quantity}
														onChange={(e) => setQuantity(e.target.value)}
													/>
													<button onClick={handleAdd}>Add Prescription</button>

													<ul style={{ listStyleType: "none", padding: 0 }}>
														{prescriptions.map((item, pindex) => (
															<li
																key={pindex}
																style={{
																	display: "flex",
																	justifyContent: "space-between",
																	alignItems: "center",
																	padding: "8px 0",
																	borderBottom: "1px solid #ddd",
																}}
															>
																{item.prescription} - {item.quantity}
																<i
																	onClick={() => handleRemove(pindex)}
																	className="fa fa-times"
																	aria-hidden="true"
																	style={{
																		cursor: "pointer",
																		color: "red",
																		marginLeft: "10px",
																	}}
																></i>
															</li>
														))}
													</ul>
												</div>
											</div>

											<div className="col-lg-12">
												<div className="write-texterea">
													<div className="form-group col-lg-12">
														<textarea
															className="form-control"
															id="message"
															rows="4"
															placeholder="Add your Prescription Detail"
															value={prescriptiondetail}
															onChange={(e) =>
																setPrescriptiondetail(e.target.value)
															}
														/>
														<div className="row p-4">
															<div className="col-lg-5">
																<div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
																	<h4 className="extra-color-10">
																		Prescribed By:
																	</h4>
																	<div className="d-flex gap-3 align-items-center">
																		<img
																			src={
																				userDetail?.profile_image_url
																					? userDetail?.profile_image_url
																					: physicianchat
																			}
																			className="img-fluid profie_img"
																			alt=""
																		/>
																		<div>
																			<h4 className="main-heading-font level-6 ">
																				Dr {userDetail?.first_name}
																			</h4>
																			<h5 className="primary-medium-font level-8 extra-color-15">
																				Physician
																			</h5>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-lg-12">
												<Link
													onClick={(e) => prescriptionHandler(e)}
													className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
												>
													<span className="loading-btn loading bg-wrapper w-100">
														{" "}
														{loading ? (
															<i className="fa fa-spinner"></i>
														) : (
															"Save Changes"
														)}
													</span>
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserWriteNow;
